export default __webpack_public_path__ + "static/media/caozuo.059466e9.jpg";